<div class="mainTitle">Meal Planner</div>  

<app-meal-notification [expiringCount]="countRes.expiring" [unassignedCount]="countRes.unassigned"></app-meal-notification>

<div class="mainTitle mt-5">Meal Plan</div> 

<div class="col-md-12 mt-4" style="padding: 0;">
    <div class="tab-row-wrapper">
    <mat-list role="list" class="meal-plan-tab-list">
        <mat-list-item role="listitem" class="meal-plan-tab-item">
            <div [ngClass]="tab1Css" (click)="changeTab('tab1')">
                <div class="tabContent">All Members</div>
            </div>
        </mat-list-item>
        <mat-list-item role="listitem" class="meal-plan-tab-item">
            <div [ngClass]="tab2Css" (click)="changeTab('tab2')" >
                <div class="tabContent">Without Meal Plan</div>
            </div>
        </mat-list-item>
        <mat-list-item role="listitem" class="meal-plan-tab-item">
            <div [ngClass]="tab3Css" (click)="changeTab('tab3')">
                <div class="tabContent">Meal Plan expiring in 3 days</div>
            </div>
        </mat-list-item>
        <mat-list-item role="listitem" class="meal-plan-tab-item">
            <div [ngClass]="tab4Css" (click)="changeTab('tab4')">
                <div class="tabContent">Templates</div>
            </div>
        </mat-list-item>
      </mat-list>
    </div>
</div>

<div class="col-md-12" style="padding: 0;" *ngIf="selectedTab !== 'tab4'">
    <div class="offset-md-9 col-md-3 textAlign mt-2">
         <input matInput type="textbox" placeholder="Search by member" class="form-control textField" [(ngModel)]="name" (keyup)="searchByMember($event)" />
    </div>
</div>

<!-- Templates tab -->
<ng-container *ngIf="selectedTab === 'tab4'">
  <app-meal-templates></app-meal-templates>
</ng-container>

<!-- Members tabs -->
<ng-container *ngIf="selectedTab !== 'tab4'">
<ng-container *ngFor="let rec of memberList;">
<div class="row mt-5 mr-3">
    <div class="col-sm-4" *ngFor="let r of rec;">
        <app-member-meal-details [memberMealDetails]="r" [selectedTab]="selectedTab"></app-member-meal-details>
    </div>
  </div>
</ng-container>
<div class="row mt-4" *ngIf="this.resp['totalCount']==0">
        No Record Found..
</div>
<div class="row mt-3 justify-content-center">
<mat-paginator #paginator
    (page)="pageChangeEvent($event)"
    [pageSize]="10"
    [pageIndex]="0"
    [length]="this.resp['totalCount']"
   
    showFirstLastButton>
  </mat-paginator>
   </div>
</ng-container>
